import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCookies } from 'react-cookie';

import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultConfig, RainbowKitProvider, darkTheme } from "@rainbow-me/rainbowkit";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi"

import { NETWORK } from "./config";

import './css/main.css';
import './css/wf-biofi.css';
import './css/remix.css';
import './css/biofi-front-end.css';

import Home from "./pages/Home";
import Login from "./pages/Login";
import DashboardOld from "./pages/DashboardOld";
import Dashboard from "./pages/Dashboard";
import BiofiStaking from "./pages/BiofiStaking";
import Stake from "./pages/Stake";
import StakeLP from "./pages/StakeLP";
import Learn from "./pages/Learn";
import Terms from "./pages/Terms";


let chains = [NETWORK];


const walletConnectProjectId = "63b3dbc5017e9b78758af2281a37c62b";

const queryClient = new QueryClient();

const config = getDefaultConfig({
  //appName: 'My RainbowKit App',
  projectId: walletConnectProjectId,
  chains: chains,
  ssr: false, // If your dApp uses server side rendering (SSR)
});


function App() {

  const [cookies] = useCookies(['userType']);
  let userType = cookies.userType;
  if (userType === undefined) {
    userType = "user";
  }

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider modalSize="compact" theme={darkTheme({ accentColor: '#344c85' })} >
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route index element={<Home />} />
                <Route path="login" element={<Login validChain={chains[0]} />} />
                <Route path="dashboardOld" element={<DashboardOld validChain={chains[0]} />} />
                <Route path="dashboard" element={<Dashboard validChain={chains[0]} />} />
                <Route path="biofiRewards" element={<BiofiStaking validChain={chains[0]} />} />
                <Route path="deposit/:stakeId" element={<Stake validChain={chains[0]} />} />
                <Route path="deposit" element={<Navigate replace to="/biofiRewards" />} />
                <Route caseSensitive path="depositLp/:stakeId" element={<StakeLP validChain={chains[0]} />} />
                <Route path="depositLp" element={<Navigate replace to="/biofiRewards" />} />
                <Route path="learn" element={<Learn />} />
                <Route path="terms" element={<Terms />} />

                <Route path="stake/*" element={<Navigate replace to="/biofiRewards" />} />
                <Route path="stake" element={<Navigate replace to="/biofiRewards" />} />
                <Route path="biofiStaking" element={<Navigate replace to="/biofiRewards" />} />
                <Route path="*" element={<Navigate replace to="/" />} />
              </Routes>
            </BrowserRouter>
          </div>
          <ToastContainer position="bottom-left" theme="dark" />

        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
